import "./../../bindings/bao-tabs";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-number-box";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import SearchPaging from "./../../factories/search-paging";
import BaoDialog from "./../../factories/bao-dialog";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
function ShiftTypeViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(ShiftTypeViewModel, SearchPaging);
ShiftTypeViewModel.prototype.PrimaryKey = "ShiftTypeId";
ShiftTypeViewModel.prototype.RefreshUrl = "ShiftType/Get";
ShiftTypeViewModel.prototype.SaveUrl = "ShiftType/Save";
ShiftTypeViewModel.prototype.DeleteUrl = "ShiftType/Delete";
ShiftTypeViewModel.prototype.IsInUseUrl = "ShiftType/IsInUse";
ShiftTypeViewModel.prototype.PermissionForward = "ShiftTypeForward";
ShiftTypeViewModel.prototype.PermissionBackward = "ShiftTypeBackward";
ShiftTypeViewModel.prototype.PermissionSave = "ShiftTypeSave";
ShiftTypeViewModel.prototype.PermissionRefresh = "ShiftTypeRefresh";
ShiftTypeViewModel.prototype.PermissionDelete = "ShiftTypeDelete";
export default ShiftTypeViewModel;